import React from 'react';
import { Form, Icon, Switch, Tooltip, Typography } from 'antd';
import DropdownSelect from '../../../../../../components/dropdownSelect';
import { getDocOptionsSelect } from '../../../../utils/getDocOptionsSelect';
import { getRenderControl } from '../../../../../../components/SingleControlCustom/getRenderControl';
import useDocumentTypeListQuery from '../../../../queries/useDocumentTypeListQuery';
import useCompanies from '../../../../../../queries/useCompanies';
import { useDispatch, useSelector } from 'react-redux';
import {
  applyCompany,
  applySource,
  applyStatuses,
  applyType,
  applyViewOtherDocsSelected,
} from '../../../../store/actions/documentFilterNew.actions';
import styles from './General.module.scss';
import useStatusesQuery from '../../../../queries/useStatusesQuery';

const sourceOptions = [
  { id: 5, name: 'Веб-приложение' },
  { id: 9, name: 'Электронная почта' },
];

const General = () => {
  const dispatch = useDispatch();

  const { data: type, isFetching: isTypeFetching } = useDocumentTypeListQuery({
    staleTime: Infinity,
  });
  const { data: companies, isFetching: isCompanyFetching } = useCompanies({
    staleTime: Infinity,
  });
  const { data: statusesData, isFetching: isFetchingStatus } = useStatusesQuery(
    {
      staleTime: Infinity,
    }
  );

  const { companyId, typeId, viewOtherDocsSelected, statuses, sourceId } =
    useSelector((state) => state.documentFilterNewStore);

  const userInfo = useSelector((state) => state.authentication.userInfo);

  const handleChangeCompany = (value) => {
    dispatch(applyCompany(value));
  };

  const handleChangeType = (value) => {
    dispatch(applyType(value));
  };

  const handleChangeStatuses = (value) => {
    dispatch(applyStatuses(value));
  };

  const handleChangeSource = (value) => {
    dispatch(applySource(value));
  };

  const disabledCompany =
    (!!companyId && companies?.length === 1) || isCompanyFetching;

  return (
    <div>
      {userInfo.SwitchToVisibility && (
        <label className={styles.filterSwitch}>
          <Switch
            checked={viewOtherDocsSelected}
            onChange={(newVal) => dispatch(applyViewOtherDocsSelected(newVal))}
          />
          <Typography.Text>
            Посмотреть все документы сотрудников{' '}
            <Tooltip
              title={`
                  При активации данной кнопки вам будут показаны документы сотрудников,
                  в которых вы не являетесь задействованным лицом. 
                  Будьте аккуратны.
                `}
              placement="bottomLeft"
            >
              <Icon type="info-circle" />
            </Tooltip>
          </Typography.Text>
        </label>
      )}
      <Form.Item
        label="Управляющая компания"
        style={{ margin: 0 }}
      >
        <DropdownSelect
          value={companyId}
          multiple={false}
          onChange={(value) => handleChangeCompany(value)}
          options={getDocOptionsSelect(companies)}
          renderControl={getRenderControl({
            options: getDocOptionsSelect(companies),
            isClear: true,
            onClearClick: () => {
              handleChangeCompany(null);
            },
            value: companyId,
            placeholder: 'Выберите из списка',
            disabled: disabledCompany,
            loading: isCompanyFetching,
          })}
        />
      </Form.Item>
      <Form.Item
        label="Тип документа"
        style={{ margin: 0 }}
      >
        <DropdownSelect
          value={typeId}
          onChange={(value) => handleChangeType(value)}
          multiple={false}
          placeholder="Тип документа"
          options={getDocOptionsSelect(type)}
          renderControl={getRenderControl({
            options: getDocOptionsSelect(type),
            isClear: true,
            value: typeId,
            onClearClick: () => {
              handleChangeType(null);
            },
            disabled: isTypeFetching,
            loading: isTypeFetching,
          })}
        />
      </Form.Item>

      <Form.Item
        label="Источник"
        style={{ margin: 0 }}
      >
        <DropdownSelect
          value={sourceId}
          onChange={(value) => handleChangeSource(value)}
          multiple={false}
          placeholder="Источник"
          options={getDocOptionsSelect(sourceOptions)}
          renderControl={getRenderControl({
            options: getDocOptionsSelect(sourceOptions),
            isClear: true,
            value: sourceId,
            onClearClick: () => {
              handleChangeSource(null);
            },
          })}
        />
      </Form.Item>
      <Form.Item
        label="Статус"
        style={{ margin: 0 }}
      >
        <DropdownSelect
          disabled={isFetchingStatus}
          loading={isFetchingStatus}
          multiple={true}
          options={getDocOptionsSelect(statusesData)}
          value={statuses}
          onChange={(value) => handleChangeStatuses(value)}
        />
      </Form.Item>
    </div>
  );
};

export default General;
